var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "magic_nav_inner" }, [
    _c(
      "div",
      {
        class: [
          "grid-container",
          "layout-" + _vm.value.config.magic_type,
          { "has-shadow": _vm.showShadow },
        ],
      },
      _vm._l(_vm.value.config.value, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "grid-item" },
          [
            _c(
              "el-image",
              { staticClass: "img", attrs: { src: item.imageurl } },
              [
                _c(
                  "div",
                  {
                    staticClass: "image-slot",
                    attrs: { slot: "error" },
                    slot: "error",
                  },
                  [_c("i", { staticClass: "el-icon-picture" })]
                ),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }